export default function () {
    function build(video) {
        if (!video) return undefined;
        return useSchema().build({
            '@type': 'VideoObject',
            name: video.video_title_full,
            thumbnailUrl: video.video_image_url,
            uploadDate: video.video_created.toISOString(),
            embedUrl: video.video_embed_url,
            description: video.video_description,
        });
    }

    return {build};
}
